import { defineRelease } from '../types'

const ADMINS = ['iam_org_admin', 'iam_superadmin', 'ticketing_admin']

export default defineRelease({
  version: '2026.11.1',
  date: '2026-11-02',
  summary: 'Deactivate clients, and bring clients over from Request Tracker.',
  entries: [
    {
      id: 'deactivate-clients',
      type: 'new',
      module: 'helpdesk',
      title: 'Deactivate a client instead of deleting it',
      body: 'A deactivated client is no longer offered for new tickets and its client users can’t sign in to the portal, while its tickets and invoices stay as they are. Reactivate it any time to restore access.',
      link: { to: '/clients', label: 'Open Clients' },
      roles: ADMINS,
      service: 'client-mgmt',
    },
    {
      id: 'import-clients-from-request-tracker',
      type: 'new',
      module: 'helpdesk',
      title: 'Bring your clients over from Request Tracker',
      body: 'Choose where your RT records each customer company — their organisation, email domain, a custom field or the queue — and imported tickets are linked to matching clients, with new ones created as needed. Email from those domains keeps arriving on the right client afterwards.',
      link: { to: '/tickets/settings?section=migration', label: 'Open Import & Migration' },
      roles: ADMINS,
      service: 'ticket-mgmt',
    },
  ],
})
